import {Component} from '@angular/core';

/** Keyboard key hint: `<app-kbd>Ctrl</app-kbd>`. */
@Component({
    selector: 'app-kbd',
    templateUrl: './kbd.component.html',
    styleUrl: './kbd.component.scss'
})
export class KbdComponent {
}
